import {UILobbyController} from '../../../shared/scripts/ui_html/lobby/UILobbyController.ts'
import {UIRoomController} from './room/UIRoomController.ts'
import {UISceneController} from './UISceneController.ts'
import {Scene} from './UISceneTypes.ts'
import {UIWAdController} from '../ui_ad/UIWAdController.ts'
import {UIUrlController} from '../../../shared/scripts/ui_html/UIUrlController.ts'
import {UIMatchmakingFindGameController} from '../ui_matchmaking/UIMatchmakingFindGameController.ts'
import {UIVLIController} from '../../../shared/scripts/ui_ad/UIVLIController.ts'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables.ts'
import {UIWManagerEvents} from './UIWManagerEvents.ts'
import {UIDManagerEvents} from './UIDManagerEvents.ts'
import {UIDiscordSceneController} from '../discord/content_frame/scenes/UIDiscordSceneController.ts'
import {UIWHeaderController} from './header/UIWHeaderController.ts'
import {UISidebarController} from './sidebar/UISidebarController.ts'
import {UIModeSelectorController} from '../../../shared/scripts/ui_html/home_page/UIModeSelectorController.ts'
import {type BotsMatchType, isBotMatchType, type MatchmakingMatchTypes, type MatchType} from '@colonist/game-base-types'
import {UILandingPageController} from './landing_page/UILandingPageController.ts'
import {UIWFooterController} from './UIWFooterController.ts'
import {type UIHeaderProfileController} from './header/UIHeaderProfileController.ts'
import {UIWModeSelectorDetailsController} from './home_page/UIWModeSelectorDetailsController.ts'
import {ClientUserState} from '../../../shared/scripts/ClientUserState.ts'
import {startBotGame} from '../../../shared/scripts/matchmaking/MatchmakingUtilsClient.ts'

export class UIManager {
    uiManagerEvents: UIWManagerEvents
    header: UIWHeaderController
    sidebar: UISidebarController
    footer: UIWFooterController
    homepageSceneContainer: HTMLDivElement
    layoutContainer: HTMLDivElement
    layoutContentWithAds: HTMLDivElement
    headerProfile: UIHeaderProfileController

    lobby: UILobbyController
    room: UIRoomController
    sceneController: UISceneController
    adController: UIWAdController
    urlController: UIUrlController
    matchmakingController: UIMatchmakingFindGameController
    vliController: UIVLIController | undefined
    discordSceneController: UIDiscordSceneController | undefined
    landingPage: UILandingPageController
    modeSelectorDetails: UIWModeSelectorDetailsController
    modeSelector: UIModeSelectorController

    constructor() {
        this.uiManagerEvents = UIUtilsEjsVariables.isUserOnDiscord ? new UIDManagerEvents(this) : new UIWManagerEvents(this)
        this.header = new UIWHeaderController()
        this.sidebar = new UISidebarController()
        this.footer = new UIWFooterController()
        this.headerProfile = this.header.headerProfileController

        this.homepageSceneContainer = document.getElementById('homepage-mode-selector-container') as HTMLDivElement
        this.layoutContainer = document.getElementById('web-layout-container') as HTMLDivElement
        this.layoutContentWithAds = document.getElementById('web-layout-content-with-ads') as HTMLDivElement

        this.lobby = new UILobbyController()
        this.room = new UIRoomController(this)
        this.adController = new UIWAdController()
        this.urlController = new UIUrlController()
        this.matchmakingController = new UIMatchmakingFindGameController(this)
        this.vliController = UIUtilsEjsVariables.isUserOnDiscord ? undefined : new UIVLIController()
        this.discordSceneController = UIUtilsEjsVariables.isUserOnDiscord ? new UIDiscordSceneController(this.sidebar) : undefined
        this.landingPage = new UILandingPageController(this)
        this.sceneController = new UISceneController(this)

        const onStartGame = async(matchType: MatchType) => {
            if(isBotMatchType(matchType)) {
                startBotGame(matchType as BotsMatchType)
                return
            }

            await ClientUserState.requireUser()
            this.matchmakingController.sendFindGameMessageToServer(matchType as MatchmakingMatchTypes)
        }

        this.modeSelectorDetails = new UIWModeSelectorDetailsController((matchType) => void onStartGame(matchType),
            (matchType) => this.modeSelector.redirectToCasualWithTransition(matchType))

        this.modeSelector = new UIModeSelectorController(Date.now(),
            (matchType) => void onStartGame(matchType),
            (matchType) => this.modeSelectorDetails.show(matchType))

        this.sidebar.setSceneNavigationCallback((scene) => {
            switch(scene) {
                case 'lobby':
                    this.sceneController.loadScene(Scene.Lobby)
                    return
                case 'play':
                    this.sceneController.loadScene(Scene.MainPage)
                    return
            }
        })

        this.sidebar.setLogoClickCallback(() => {
            const sceneToLoad = UISceneController.shouldShowLandingPage() ? Scene.LandingPage : Scene.MainPage
            this.sceneController.loadScene(sceneToLoad)
        })

        this.header.setLogoClickCallback(() => {
            const sceneToLoad = UISceneController.shouldShowLandingPage() ? Scene.LandingPage : Scene.MainPage
            this.sceneController.loadScene(sceneToLoad)
        })
    }

    init() {
        this.matchmakingController.init()
    }

    // eslint-disable-next-line class-methods-use-this
    clearDOM() {
        const mainContainer = document.getElementById('main_container')
        if(mainContainer != undefined) mainContainer.remove()
    }

    async goToMainPageAndSelectMatchType(matchType: MatchType) {
        await this.modeSelector.waitUntilInitialized
        this.sceneController.loadScene(Scene.MainPage)
        this.modeSelector.selectCardByMatchType(matchType)
    }
}
